export const CardPointeVoidOutcome = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeVoidOutcome =
    (typeof CardPointeVoidOutcome)[keyof typeof CardPointeVoidOutcome];

export interface CardPointeVoidRequestBody {
    readonly merchid: string;
    readonly retref: string;
    readonly amount?: string;
}

export interface CardPointeVoidRequestDetails {
    readonly method: 'POST';
    readonly path: '/cardconnect/rest/void';
    readonly body: CardPointeVoidRequestBody;
}

export interface CardPointeVoidResponseBody {
    readonly respstat: 'A' | 'B' | 'C';
    readonly merchid?: string;
    readonly orderId?: string;
    readonly authcode?: string;
    readonly amount?: string;
    readonly currency?: string;
    readonly retref?: string;
    readonly respcode?: string;
    readonly respproc?: string;
    readonly resptext?: string;
    readonly receipt?: unknown;
    readonly receiptObj?: unknown;
    readonly fee_amount?: string;
    readonly fee_value?: string;
    readonly fee_type?: 'SURCHRG' | 'SURCHRG_WAIVED';
    readonly fee_format?: 'percent' | '';
    readonly fee_authcode?: string;
    readonly fee_merchid?: string;
    readonly fee_retref?: string;
}

export interface CardPointeVoidApprovedBody extends CardPointeVoidResponseBody {
    readonly respstat: 'A';
    readonly retref: string;
    readonly merchid: string;
    readonly authcode: string;
}

export interface CardPointeVoidDeclinedBody extends CardPointeVoidResponseBody {
    readonly respstat: 'B' | 'C';
    readonly resptext: string;
}

export interface CardPointeVoidApprovedResponseDetails {
    readonly outcome: typeof CardPointeVoidOutcome.APPROVED;
    readonly httpStatus: 200;
    readonly body: CardPointeVoidApprovedBody;
}

export interface CardPointeVoidDeclinedResponseDetails {
    readonly outcome: typeof CardPointeVoidOutcome.DECLINED;
    readonly httpStatus: 200;
    readonly body: CardPointeVoidDeclinedBody;
}

export interface CardPointeVoidMalformedResponseDetails {
    readonly outcome: typeof CardPointeVoidOutcome.MALFORMED_RESPONSE;
    readonly httpStatus: number;
    readonly body: unknown;
    readonly message: string;
}

export type CardPointeVoidResponseDetails =
    | CardPointeVoidApprovedResponseDetails
    | CardPointeVoidDeclinedResponseDetails
    | CardPointeVoidMalformedResponseDetails;
